import { useAtomValue } from 'jotai/react'

import { addressAtom, isConnectedAtom } from '@/stores/trade'

const useWallet = () => {
  const address = useAtomValue(addressAtom)
  const isConnected = useAtomValue(isConnectedAtom)

  return {
    address,
    isConnected
  }
}

export default useWallet
